export const doorColor = 0x00ff00; // green
export const darkSlateGray = 0x121f1f;
export const hoppiColor = 0xffff00; // yellow
export const eyeColor = 0xffffff; // white
export const primaryColor = 0x00ffff; // cyan
export const selectColor = 0xec407a; // pinkish

export const lineWidth = 2;

export const doorWidth = 100;
export const doorHeight = 160;

export const hoppiSize = 40;

export const levelStorageKey = 'level';
export const gridCellSizeStorageKey = 'gridCellSize';
